<template>
    <div class="download">

        <el-steps direction="vertical" :active="active" style="margin: 0 auto;">
            <el-step :title="$t('第一步') + '：' + $t('选择题型')">
                <template v-for="(sort, index) in sorts">
                    <el-card slot="description" class="margin" :key="index"
                        v-if="sort.types.filter((item) => { return item.is_download == 1 }).length > 0">
                        <div slot="header" class="flex flex-v-center flex-between">
                            <h3>{{ sort.title }}</h3>
                        </div>

                        <div class="flex flex-wrap">
                            <el-radio border class="margin" size="medium" v-model="tag"
                                v-for="(type, index1) in sort.types.filter((item) => { return item.is_download == 1 })"
                                :key="index1" :label="type.tag">{{ type.tag2 || type.tag }}</el-radio>
                        </div>
                    </el-card>
                </template>
            </el-step>
            <el-step :title="$t('第二步') + '：' + $t('筛选条件（可不选）')">
                <el-card class="margin" slot="description">
                    <template v-if="$store.state.mode == 'PTE'">
                        <div class="flex ">
                            <el-checkbox-group class="flex flex-v-center" v-model="options" size="small">
                                <el-checkbox class="margin" label="仅预测题" border>{{ $t('仅预测题') }}</el-checkbox>
                                <el-checkbox v-if="tag == 'RS'" class="margin" label="仅机经" border>{{ $t('仅机经')
                                }}</el-checkbox>
                                <el-checkbox v-if="$store.state.lang != 'en'" class="margin" label="有中文翻译" border>{{
                                    $t('有中文翻译') }}</el-checkbox>

                                <el-checkbox v-if="tag == 'DI' || tag == 'RL'" class="margin" label="参考答案" border>{{
                                    $t('参考答案')
                                }}</el-checkbox>
                                <el-checkbox v-if="(tag == 'WE' || tag == 'WE-Core')" class="margin" label="参考答案"
                                    border>{{
                                        $t('范文')
                                    }}</el-checkbox>


                                <el-checkbox class="margin" label="新题在前" border>{{ $t('新题在前') }}</el-checkbox>

                                <el-checkbox v-if="tag == 'RS' || tag == 'WFD'" class="margin" label="类别划分" border>{{
                                    $t('类别划分')
                                }}</el-checkbox>

                                <el-checkbox v-if="$store.state.lang != 'en' && (tag == 'RS' || tag == 'WFD')"
                                    class="margin" label="意群分割" border>{{
                                        $t('意群分割')
                                    }}</el-checkbox>

                                <el-checkbox v-if="tag == 'WFD' && $store.state.lang != 'en'" class="margin"
                                    label="机经点评" border>{{
                                        $t('机经点评')
                                    }}</el-checkbox>
                                <el-checkbox v-if="(tag == 'SST') && $store.state.lang != 'en'" class="margin"
                                    label="思维导图" border>{{
                                        $t('思维导图')
                                    }}</el-checkbox>

                                <el-checkbox class="margin"
                                    v-if="['RA', 'RS', 'DI', 'RL', 'RTS', 'SGD', 'RO', 'FIB-R', 'SST', 'WFD', 'FIB-RW'].indexOf(tag) != -1 && $store.state.lang != 'en'"
                                    label="难度排序" border>{{ $t('难度排序') }}</el-checkbox>


                            </el-checkbox-group>

                        </div>
                        <el-divider></el-divider>
                    </template>
                    <div class="flex flex-v-center margin-l">
                        <div>{{ $t('按星级') }}：</div>
                        <el-checkbox-group class="flex flex-v-center" v-model="options" size="small">
                            <el-checkbox class="margin" label="星级" border>{{ $t('星级') }}</el-checkbox>
                            <el-rate v-if="stars > 0" v-model="stars" class="margin-l"></el-rate>
                        </el-checkbox-group>
                    </div>

                    <div class="flex flex-v-center margin-l">
                        <div>{{ $t('自定义') }}：</div>
                        <el-checkbox-group class="flex flex-v-center" v-model="favoriteIds" size="small">
                            <el-checkbox class="margin" :label="favorite.id" border v-for="(favorite, i) in favorites"
                                :key="i">{{
                                    $t(favorite.title) }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-card>
            </el-step>
            <el-step :title="$store.state.mode == 'PTE' ? ($t('第三步') + '：' + $t('一键导出')) : $t('第二步：一键导出')">

                <div class="center" slot="description">
                    <el-button @click="download" :disabled="!tag" icon="el-icon-download" round type="primary"
                        class="margin-lt">{{
                            $t('开始下载') }}</el-button>
                </div>
            </el-step>
        </el-steps>




        <el-dialog top="20%" custom-class="br" :visible.sync="centerDialogVisible" :close-on-click-modal="false"
            :show-close="false" width="30%" center>
            <h4 slot="title">{{ $t('请选择您的操作') }}</h4>

            <span slot="footer" class="dialog-footer center">
                <el-button size="small" @click="centerDialogVisible = false">{{ $t('取 消') }}</el-button>
                <el-button size="small" class="margin-x" type="danger" @click="drop">{{ $t('删 除') }}</el-button>
                <el-button size="small" type="primary" @click="create()">{{ $t('下 载') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            active: 0,
            tag: "",
            options: [],
            item: {},
            centerDialogVisible: false,
            list: [],
            tab: "download",
            loading: false,
            stars: 0,
            favoriteIds: [],
            favorites: [],
        };
    },

    watch: {
        tag: function (val) {
            if (val) {
                this.active = 3;
            }

            if (val != 'RS' || val != 'WFD') {
                let index = -1;
                ["机经点评", "意群分割"].forEach((option) => {
                    index = this.options.findIndex((val) => {
                        return val == option
                    })
                    if (index != -1) {
                        this.options.splice(index, 1)
                    }
                })
            }

            if (this.options.indexOf('难度排序') != -1 && ['RA', 'RS', 'DI', 'RL', 'RO', 'FIB-R', 'SST', 'WFD'].indexOf(val) == -1) {
                this.options.splice(this.options.indexOf('难度排序'), 1)
            }
        },
        options: function (val) {
            if (val.indexOf("星级") == -1) {
                this.stars = 0;
            } else {
                if (this.stars == 0) {
                    this.stars = 1;
                }
            }
        }
    },

    computed: {
        sorts: function () {
            return this.$store.getters.getSorts();
        }

    },

    created() {
        this.query_favorites()
    },

    methods: {

        query_favorites() {
            this.$http.post("/api/source/mine/favorite/list").then((favorites) => {
                this.favorites = favorites;
            })
        },

        to1(item) {
            this.item = item;
            this.centerDialogVisible = true;
        },
        tabChange() {
            if (this.tab == "history") {
                this.query1();
            }
        },

        download() {
            if (this.$store.getters.getRole() == 0) {
                this.$vip_alert("此功能", "")
                return;
            }
            this.$http.post("/api/source/download", { tag: this.tag, options: this.options, stars: this.stars, favorite_ids: this.favoriteIds, lang: this.$store.state.lang }).then((info) => {
                window.open(this.$host + "/api/pdf/" + info.uuid);
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });
            })
        },

        query() {
            this.$http.post("/api/source/download/info").then((info) => {
                if (info.id) {
                    this.info = info;
                    if (this.info.status == 1) {
                        this.loading = false;
                        this.tab = "history";
                    } else {
                        this.loading = true;

                        setTimeout(() => {
                            this.query();
                        }, 10000);
                    }
                } else {
                    this.loading = false;
                }
            })
        },


        create() {
            this.centerDialogVisible = false;
            window.open(this.$host + "/api/pdf/" + this.item.uuid);
        },

        drop() {
            this.centerDialogVisible = false;
            this.$confirm('', this.$t('确认删除本次生成记录') + '?', {
                center: true,
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
                type: 'primary'
            }).then(() => {
                this.$http.post("/api/source/download/remove", { id: this.item.id }).then(() => {
                    this.query1();
                })
            });
        },

        query1() {
            this.$http.post("/api/source/download/list").then((list) => {
                this.list = list;
            })
        },
    },
};
</script>
<style scoped>
.download>>>.el-step__description {
    padding-right: 0;
}

.download>>>.el-radio {
    align-items: flex-start !important;
}

.download>>>.el-divider {
    margin: 10px 0;
}

.download>>>.el-card__header {
    padding: 10px 20px;
}
</style>
